import { useTranslation } from "react-i18next";
import { Ban, Bell, Eye, EyeOff, Lock, Tag, TriangleAlert, type LucideIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const EXTRAS: { key: string; icon: LucideIcon }[] = [
  { key: "trackers", icon: EyeOff },
  { key: "private", icon: Lock },
  { key: "live", icon: Bell },
  { key: "notes", icon: Tag },
];

export function Protection() {
  const { t } = useTranslation("landing");

  return (
    <section
      id="protection"
      className="mx-auto max-w-[1200px] scroll-mt-24 px-5 pt-24 md:px-10 md:pt-32"
    >
      <SectionHeading
        eyebrow={t("protection.eyebrow")}
        title={t("protection.title")}
        subtitle={t("protection.subtitle")}
      />

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        <article className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-6 shadow-card">
          <Eye className="size-5" />
          <h3 className="text-lg font-semibold tracking-[-0.02em]">
            {t("protection.cards.leaked.title")}
          </h3>
          <p className="text-[15px] leading-relaxed text-muted-foreground">
            {t("protection.cards.leaked.body")}
          </p>
        </article>

        <article className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-6 shadow-card">
          <TriangleAlert className="size-5" />
          <h3 className="text-lg font-semibold tracking-[-0.02em]">
            {t("protection.cards.phishing.title")}
          </h3>
          <p className="text-[15px] leading-relaxed text-muted-foreground">
            {t("protection.cards.phishing.body")}
          </p>
          <div className="mt-auto flex items-center gap-2 rounded-lg bg-warn-soft px-3.5 py-3 text-[13px] text-warn">
            <TriangleAlert className="size-3.5 shrink-0" />
            <span>
              {t("protection.cards.phishing.example")}{" "}
              <span className="font-mono text-xs">github-signup@</span>
            </span>
          </div>
        </article>

        <article className="flex flex-col gap-3 rounded-2xl border border-border bg-card p-6 shadow-card">
          <Ban className="size-5" />
          <h3 className="text-lg font-semibold tracking-[-0.02em]">
            {t("protection.cards.block.title")}
          </h3>
          <p className="text-[15px] leading-relaxed text-muted-foreground">
            {t("protection.cards.block.body")}
          </p>
        </article>
      </div>

      <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {EXTRAS.map(({ key, icon: Icon }) => (
          <div key={key} className="flex flex-col gap-2.5">
            <span className="flex size-9 items-center justify-center rounded-lg bg-accent">
              <Icon className="size-[17px] text-primary" />
            </span>
            <h3 className="font-semibold">{t(`protection.extras.${key}.title`)}</h3>
            <p className="text-sm leading-relaxed text-muted-foreground">
              {t(`protection.extras.${key}.body`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
